module.exports = __webpack_public_path__ + "8720218982040973764a3f54d559d1c1.png";